export default "__VITE_ASSET__Bfo5uMqZ__"